import { GenericInformationTemplateComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/generic-information-template/generic-information-template.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, GenericInformationTemplateComponent],
  selector: 'app-information-cancel',
  templateUrl: './information-cancel.component.html',
})
export class InformationCancelComponent  {
  
}
